module.exports = __webpack_public_path__ + "img/icon_ai_change@2x.c29b4e9c.png";